export default __webpack_public_path__ + "static/0273-9ea2a10861c676d636fbf70404a728b3.png";